var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gender_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1158.3 1018.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 70
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#F9AF1C"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 289.5,
    cy: 289.5,
    r: 254.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M289.3 545.4v437.8M111.6 757.1h349.6"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#35A4DD"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 868.8,
    cy: 722.9,
    r: 254.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M867.1 99v369.9M862.1 96.9L676.4 282.5M868.6 96.9l185.6 185.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default ForwardRef;